import {
  DEFAULT_FIELD_DELIMITER,
  DEFAULT_SUBFIELD_DELIMITER,
  estimateNameLength,
} from '@inference.engine/taxonomy/web';
import type { TaxonomyField, TaxonomySettings } from '@/entities/taxonomy';
import { resolveChannelLimit } from './channelLimits';

export interface ChannelStatus {
  platform: string;
  limit: number;
  length: number;
  over: boolean;
  overBy: number;
}

/**
 * Per-platform character status for the selected platforms that have a limit
 * (built-in or overridden). Platforms with no known limit are omitted.
 */
export function channelStatuses(
  fields: TaxonomyField[],
  settings: TaxonomySettings | undefined,
  platforms: string[],
): ChannelStatus[] {
  const length = estimateNameLength(fields, {
    fieldDelimiter: settings?.fieldDelimiter || DEFAULT_FIELD_DELIMITER,
    subfieldDelimiter: settings?.subfieldDelimiter || DEFAULT_SUBFIELD_DELIMITER,
  });
  return platforms
    .map((platform) => {
      const limit = resolveChannelLimit(platform, settings?.channelLimits);
      if (limit == null) return null;
      return {
        platform,
        limit,
        length,
        over: length > limit,
        overBy: Math.max(0, length - limit),
      };
    })
    .filter((s): s is ChannelStatus => s !== null);
}
